// src/pages/SetPasswordPage.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EmailAuthProvider, linkWithCredential } from 'firebase/auth';
import { auth } from '../firebase/config';
import { useAuth } from '../hooks/useAuth';
import Navbar from '../components/Navbar';

export default function SetPasswordPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError(t('setPassword.tooShort')); return; }
    if (password !== confirmPassword) { setError(t('setPassword.mismatch')); return; }
    setLoading(true);
    try {
      const credential = EmailAuthProvider.credential(user.email, password);
      await linkWithCredential(auth.currentUser, credential);
      await auth.currentUser.reload();
      navigate('/dashboard');
    } catch (err) {
      if (err.code === 'auth/provider-already-linked') {
        navigate('/dashboard');
      } else {
        setError(err.message || t('setPassword.failed'));
      }
    } finally { setLoading(false); }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  if (!user) return null;

  return (
    <div className="page">
      <Navbar />
      <div className="container" style={{ paddingTop: 48, paddingBottom: 60 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h1 style={{ fontSize: '1.5rem', marginBottom: 4 }}>{t('setPassword.title')}</h1>
          <p style={{ color: 'var(--muted)', fontSize: '0.86rem', lineHeight: 1.5 }}>
            {t('setPassword.subtitle')}
          </p>
        </div>
        <div className="card">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">{t('setPassword.email')}</label>
              <input className="form-input" value={user.email} disabled style={{ background: '#f8fafc', color: 'var(--muted)' }} />
            </div>
            <div className="form-group">
              <label className="form-label">{t('setPassword.password')}</label>
              <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder={t('setPassword.passwordPlaceholder')} minLength={6} />
            </div>
            <div className="form-group">
              <label className="form-label">{t('setPassword.confirmPassword')}</label>
              <input className="form-input" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required placeholder={t('setPassword.confirmPlaceholder')} />
            </div>
            {error && <p className="error-msg">{error}</p>}
            <button className="btn btn-primary" type="submit" disabled={loading} style={{ marginTop: 6 }}>
              {loading ? t('setPassword.setting') : t('setPassword.setPassword')}
            </button>
          </form>
        </div>
        <button
          onClick={handleLogout}
          style={{ display: 'block', width: '100%', background: 'none', border: 'none', color: 'var(--muted)', fontSize: '0.82rem', cursor: 'pointer', padding: '14px 0', fontFamily: 'inherit', textAlign: 'center' }}
        >
          {t('setPassword.logOut')}
        </button>
      </div>
    </div>
  );
}
